import { useStores } from '@/store';
import { observer } from 'mobx-react';
import React from 'react';
import { Form, FormField, FormGroup } from 'semantic-ui-react';
import { FormTextInput } from '../Form';
import style from './onboarding-submission-details.less';

export const OnboardingSubmissionDetailsAddressContact = observer(() => {
  const { temporaryEmployeeStore } = useStores();

  const addressOne = temporaryEmployeeStore.current?.addressOne;
  const addressTwo = temporaryEmployeeStore.current?.addressTwo;
  const city = temporaryEmployeeStore.current?.city;
  const region = temporaryEmployeeStore.current?.region;
  const postalCode = temporaryEmployeeStore.current?.postalCode;
  const country = temporaryEmployeeStore.current?.country;
  const phoneNumbers = temporaryEmployeeStore.current?.phoneNumbers;
  const email = temporaryEmployeeStore.current?.user?.email;

  return (
    <>
      <Form className={style.form_container}>
        <fieldset>
          <legend>HOME ADDRESS</legend>
          <FormGroup inline className={style.form_group}>
            <FormField width={16}>
              <label htmlFor="addressOne" className={style.form_label} style={{ minWidth: 60 }}>
                ADDRESS
              </label>
              <FormTextInput id="addressOne" name="Address One" value={addressOne} copyable />
            </FormField>
          </FormGroup>

          <FormGroup inline className={style.form_group}>
            <FormField width={16}>
              {/* eslint-disable-next-line jsx-a11y/label-has-associated-control */}
              <label
                htmlFor="addressTwo"
                className={style.form_label}
                style={{ minWidth: 60, visibility: 'hidden' }}
              />
              <FormTextInput id="addressTwo" value={addressTwo} copyable />
            </FormField>
          </FormGroup>

          <FormGroup inline className={style.form_group}>
            <FormField width={16}>
              <label htmlFor="city" className={style.form_label} style={{ minWidth: 60 }}>
                CITY
              </label>
              <FormTextInput id="city" name="City" value={city} copyable />
            </FormField>
          </FormGroup>

          <FormGroup inline className={style.form_group}>
            <FormField width={6}>
              <label htmlFor="region" className={style.form_label} style={{ minWidth: 60 }}>
                PROVINCE
              </label>
              <FormTextInput id="region" name="Province" value={region} copyable />
            </FormField>
            <FormField width={10}>
              <label
                htmlFor="postalCode"
                className={style.form_label}
                style={{ minWidth: 60, marginLeft: 14 }}
              >
                POSTAL CODE
              </label>
              <FormTextInput id="postalCode" name="Postal Code" value={postalCode} copyable />
            </FormField>
          </FormGroup>

          <FormGroup inline className={style.form_group}>
            <FormField width={16}>
              <label htmlFor="country" className={style.form_label} style={{ minWidth: 60 }}>
                COUNTRY
              </label>
              <FormTextInput id="country" name="Country" value={country} copyable />
            </FormField>
          </FormGroup>
        </fieldset>

        <FormGroup inline style={{ alignItems: 'flex-start', marginTop: 20 }}>
          <div style={{ width: '62.5%' }}>
            {phoneNumbers?.map(({ phoneNumber, type }) => (
              <FormField width={16} style={{ marginBottom: 16 }}>
                <label htmlFor="region" className={style.form_label} style={{ minWidth: 100 }}>
                  PHONE ({type.toUpperCase()})
                </label>
                <FormTextInput id="phoneNumber" name="Phone" value={phoneNumber} copyable />
              </FormField>
            ))}
          </div>

          <FormField width={10}>
            <label
              htmlFor="email"
              className={style.form_label}
              style={{ minWidth: 80, marginLeft: 14 }}
            >
              MAIN EMAIL
            </label>
            <FormTextInput id="email" name="Email" value={email} copyable />
          </FormField>
        </FormGroup>
      </Form>
    </>
  );
});
